import { render, staticRenderFns } from "./ProDetPhase.vue?vue&type=template&id=2958f861&"
import script from "./ProDetPhase.vue?vue&type=script&lang=js&"
export * from "./ProDetPhase.vue?vue&type=script&lang=js&"
import style0 from "./ProDetPhase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports